import { dehydrate, HydrationBoundary } from '@tanstack/react-query';
import { Suspense } from 'react';

import { isArrayWithLength } from '@natu/utils/isArrayWithLength';

import { getQueryClient } from '../../../../../getQueryClient';
import { resolveStoryblokStyles, sbEditable, type Spacing, type SBProps } from '../../../../utils';
import { getJobOfferItems, getJobOfferItemsQueryKey } from './getJobOfferItems';
import { JobOfferCards, JobOfferCardsSkeleton } from './JobOfferCards';

type SBJobOfferCardsProps = {
  mt?: Spacing;
  mtTablet?: Spacing;
  mtDesktop?: Spacing;
  mb?: Spacing;
  mbTablet?: Spacing;
  mbDesktop?: Spacing;
  jobOffers: string[];
};

export const SBJobOfferCards = ({ blok }: SBProps<SBJobOfferCardsProps>) => {
  const { mt, mtTablet, mtDesktop, mb, mbTablet, mbDesktop, jobOffers } = blok;

  const storyblokStyles = resolveStoryblokStyles({
    mt,
    mtTablet,
    mtDesktop,
    mb,
    mbTablet,
    mbDesktop,
  });

  const jobOfferItems = jobOffers;

  if (!isArrayWithLength(jobOffers)) {
    return null;
  }

  const queryClient = getQueryClient();

  queryClient.prefetchQuery({
    queryKey: getJobOfferItemsQueryKey({ jobOfferItems, draftMode: false }),
    queryFn: async () => getJobOfferItems({ jobOfferItems, draftMode: false }),
  });

  return (
    <HydrationBoundary state={dehydrate(queryClient)}>
      <Suspense fallback={<JobOfferCardsSkeleton className={storyblokStyles} />}>
        <JobOfferCards
          jobOfferItems={jobOfferItems}
          className={storyblokStyles}
          {...sbEditable(blok)}
        />
      </Suspense>
    </HydrationBoundary>
  );
};
